import {ErrorType, ResponseData, showDialog, showSnackbar, validateEmail} from '@dvrd/dvr-controls';
import React, {ForwardedRef, forwardRef, useContext, useImperativeHandle, useState} from 'react';
import {login, logout} from "../../../util/requestSender";
import {AppContext} from "../../context/appContext";
import {ActivateHandle} from "../../../util/interfaces";
import User from "../../../models/userModel";
import {createErrorMessage} from "../../../util/utils";
import LoginPopup from "./loginPopup";

function LoginController(props: {}, ref: ForwardedRef<ActivateHandle>) {
    const context = useContext(AppContext);
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<ErrorType>(null);

    function onActivate() {
        setOpen(true);
    }

    function onClose() {
        setOpen(false);
    }

    function onChangeEmail(value: string) {
        onResetError();
        setEmail(value);
    }

    function onChangePassword(value: string) {
        onResetError();
        setPassword(value);
    }

    function onResetError() {
        setError(null);
    }

    function onSubmit() {
        if (!validateValues()) return;
        setLoading(true);
        login({
            data: {email, password}, callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    context.onChangeContext({user: new User(data.user)});
                    onClose();
                    setEmail('');
                    setPassword('');
                    showSnackbar('Je bent succesvol ingelogd');
                } else showDialog(createErrorMessage(data.message ?? 'Het inloggen is niet gelukt.'),
                    'Inloggen mislukt');
            }
        });
    }

    function onLogout() {
        setLoading(true);
        logout({
            callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    onClose();
                    context.onChangeContext({user: null});
                    showSnackbar('Je bent uitgelogd');
                } else showDialog(createErrorMessage(data.message ?? 'Het uitloggen is niet gelukt.'),
                    'Uitloggen mislukt');
            }
        })
    }

    function validateValues(): boolean {
        let error: ErrorType = null;
        if (!email) error = 'Vul je e-mailadres in';
        else if (!validateEmail) error = 'Vul een geldig e-mailadres in';
        else if (!password) error = 'Vul je wachtwoord in';
        if (error) setError(error)
        return !error;
    }

    useImperativeHandle(ref, () => ({activate: onActivate}));

    return (
        <LoginPopup onClose={onClose} onChangeEmail={onChangeEmail} onChangePassword={onChangePassword}
                    onSubmit={onSubmit} onLogout={onLogout} onResetError={onResetError} open={open} email={email}
                    password={password} loading={loading} error={error}/>
    );
}

export default forwardRef<ActivateHandle, {}>(LoginController);